module.exports = __webpack_public_path__ + "fonts/HelveticaNeueLTPro-Md.7d9ffeb.woff";